import { render, staticRenderFns } from "./userRecordParticulars.vue?vue&type=template&id=de042dc6&scoped=true&"
import script from "./userRecordParticulars.vue?vue&type=script&lang=js&"
export * from "./userRecordParticulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de042dc6",
  null
  
)

export default component.exports